import { FormControlLabel, Grid, Typography, Checkbox } from "@mui/material";
import { useState } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import ErrorMessage from '../../../components/Error/ErrorMessage';
import { ReduxFormField } from '../../../components/FormInput/ReduxWrappers';
// import TermsFrame from '../../../components/TernsFrame/TermsFrame'
import { selectIsMobile } from '../../../selectors/users';
import { ReduxForm } from '../../../types/forms';
import { Parking } from '../../../types/propValues/apartments';
// import { ShowingTypes } from '../../../types/showings'
import { StateInterface } from '../../../types/states';
import { required, 
// requiredFalsyString,
noSpacesPhoneNum, validatePassword, noSpaceValue, validatePhoneNumber, isInvalidCharacters, stripSpaces } from '../../../utils/validation/forms';
import Suggest from '../Stepper/Steps/Suggest';
import { MyInput } from '../../NewApplication/Fields';
import { BackButton } from '../Stepper/BackButton';
import SubmitButton from '../Stepper/SubmitButton';
import { WithStyles, makeStyles } from "@mui/styles";
import { commonCardStyles } from '../../../styles/commonCards';
import StepFailMessage from '../Stepper/StepFailMessage';
const useStyles = makeStyles(({ breakpoints }) => ({
    confirmRow: {
        '& > label': {
            alignItems: 'start'
        }
    },
    checkboxes: {
        marginLeft: '0',
        marginRight: '0',
        alignItems: 'start',
    },
    // confirmField: {
    //   marginTop: '16px !important'
    // },
    confirmTextDiv: {
        padding: '25px 0 25px 0',
        marginLeft: '5px'
    },
    checkboxContainer2: {
        alignItems: 'center !important',
        ...commonCardStyles.cardBackgroundColor,
        ...commonCardStyles.cardRadius10
    },
    checkboxHighlightBox: {
        ...commonCardStyles.cardBackgroundColor,
        ...commonCardStyles.cardRadius10,
        width: '100%',
        marginTop: '10px',
        border: '1px solid #F1D9C0',
        padding: '0 0 0px 5px'
    },
    infoBoxWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        [breakpoints.between('sm', 'md')]: {
            justifyContent: 'center'
        }
    },
    contactSubheading: {
        fontFamily: 'CircularBold',
        fontSize: '16px',
    }
}));
interface ApartmentConfirmationFormProps extends WithStyles<string>, WithTranslation, ReduxForm {
    updateApartmentConfirmation: (arg: any) => any;
    isDisabled: boolean;
    confirm: boolean;
    serviceFeeCommitment: boolean;
    isSVAMember: boolean;
    isBeforeLogin?: boolean;
    createdAt: number | undefined;
    currentStep: any;
    doStepBack: any;
    isMobile: any;
    beforeLogin?: boolean;
    name: string;
    phoneNumber: string;
    email: string;
    password: string;
}
// const getWaterFeeAdornment = (waterFeeBasis: WaterFeeBasis) => {
//   const abbreviation =
//     waterFeeBasis === 'perTenant' || waterFeeBasis === 'metered'
//       ? 'perPersonPerMonth'
//       : 'perMonth'
//   return `€${i18n.t(`abbreviations.${abbreviation}`)}`
// }
export const showParking = (parking: Parking | undefined): boolean => parking ? parking !== 'no' && parking !== 'notSure' : false;
const ApartmentConfirmationForm = ({ t, handleSubmit, submitting, error, updateApartmentConfirmation, classes, isDisabled, confirm, serviceFeeCommitment, isSVAMember, isBeforeLogin, createdAt, doStepBack, currentStep, isMobile, beforeLogin, name, phoneNumber, email, password }: ApartmentConfirmationFormProps) => {
    const styles = useStyles();
    const [, setIsEmpty] = useState(false);
    // Vaihe 12 on molemmissa poluissa yhteystiedot ja vahvistus; hakemustyyppiä ei valita (aina suppea)
    const showContactStep = currentStep === 12;
    // Ennen kirjautumista: tilin luonti + yhteystiedot; kirjautuneena: yhteystiedot ja vahvistus
    const contactStepHeadingKey = beforeLogin ? 'step12heading' : 'confirmHeading';
    return (<form noValidate onSubmit={handleSubmit(updateApartmentConfirmation)}>
      <Grid container justifyContent='space-between'>
        <Grid container>
          {showContactStep && (<>
              <Grid container>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Grid className={classes.largeForm} container>
                    <Grid item sm={12}>
                      <Typography variant='h5' gutterBottom>
                        {t(`apartment.steps.${contactStepHeadingKey}`)}
                      </Typography>
                    </Grid>
                    <Grid container spacing={1}>
                        {beforeLogin && (<>
                            <Grid item sm={12}>
                              <Typography variant='subtitle2' gutterBottom>
                                {t('signup.passwordHelper')}
                              </Typography>
                            </Grid>
                            {/* Additional notes field removed */}
                            <Grid item xs={12} sm={6}>
                              <Typography variant='body1' gutterBottom component='label' htmlFor='field-name'>
                                {t('person.fullName')}
                              </Typography>
                              <ReduxFormField name='name' validate={[required, isInvalidCharacters]} component={MyInput} style={{
                    width: '100%',
                    height: '58px',
                    padding: '20px',
                    background: '#E7ECEF'
                }} required/>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography variant='body1' gutterBottom component='label' htmlFor='field-phoneNumber'>
                                {t('person.phoneNum')}
                              </Typography>
                              <ReduxFormField autoComplete='tel' name='phoneNumber' component={MyInput} style={{
                    width: '100%',
                    height: '58px',
                    padding: '20px',
                    background: '#E7ECEF'
                }} validate={[
                    required,
                    noSpacesPhoneNum,
                    validatePhoneNumber,
                ]} required/>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                              <Typography variant='body1' gutterBottom component='label' htmlFor='field-email'>
                                {t('person.email')}
                              </Typography>
                              <ReduxFormField autoComplete='username' name='email' component={MyInput} style={{
                    width: '100%',
                    height: '58px',
                    padding: '20px',
                    background: '#E7ECEF'
                }} preventSpaces validate={[required, noSpaceValue]} normalize={stripSpaces} required/>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant='body1' gutterBottom component='label' htmlFor='field-password'>
                                {t('person.password')}
                              </Typography>
                              <ReduxFormField autoComplete='new-password' name='password' component={MyInput} style={{
                    width: '100%',
                    height: '58px',
                    padding: '20px',
                    background: '#E7ECEF'
                }} type='password' helperText={t('changePw.helperText')} validate={[
                    required,
                    validatePassword,
                    noSpaceValue
                ]} required/>
                            </Grid>
                          </>)}
                          {/* Additional notes field removed for afterLogin */}
                        <Grid item xs={12} sm={12} className={styles.confirmRow} style={{ marginBottom: '10px' }}>
                          <div className={styles.checkboxHighlightBox}>
                            <Field name='confirm' component={({ input }: any) => (<FormControlLabel className={`${styles.checkboxes} ${styles.checkboxContainer2}`} control={<Checkbox checked={Boolean(input.value)} onChange={(_, checked) => input.onChange(checked)} style={{ color: '#4f9b44' }} disabled={isDisabled}/>} label={<div className={styles.confirmTextDiv}>
                                      {t('apartment.confirmation.confirmPart')}

                                      <a style={{
                        textDecoration: 'none',
                        color: 'inherit'
                    }} target='blank' href='/terms-of-service'>
                                        {t('apartment.confirmation.confirmPartLink1')}
                                      </a>
                                      {t('apartment.confirmation.confirmDivider')}
                                      <a style={{
                        textDecoration: 'none',
                        color: 'inherit'
                    }} target='blank' href='/privacy-policy'>
                                        {t('apartment.confirmation.confirmPartLink2')}
                                      </a>
                                    </div>}/>)}/>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} className={styles.confirmRow} style={{ marginBottom: '10px' }}>
                          <div className={styles.checkboxHighlightBox}>
                            <Field name='serviceFeeCommitment' component={({ input }: any) => (<FormControlLabel className={`${styles.checkboxes} ${styles.checkboxContainer2}`} control={<Checkbox checked={Boolean(input.value)} onChange={(_, checked) => input.onChange(checked)} style={{ color: '#4f9b44' }} disabled={isDisabled}/>} label={<div className={styles.confirmTextDiv}>
                                      {t('apartment.confirmation.serviceFeeCommitment')}{' '}
                                      {t('apartment.confirmation.serviceFeeTermsPrefix')}
                                      <a style={{
                        textDecoration: 'underline',
                        color: 'inherit'
                    }} target='blank' href='/terms-of-service'>
                                        {t('apartment.confirmation.serviceFeeTermsLink')}
                                      </a>.
                                    </div>}/>)}/>
                          </div>
                        </Grid>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                      <ErrorMessage error={error}/>
                      {error === t('error.beforeLoginApartment.NotAuthorizedException') && (<RouterLink to='/forgotpassword/request' rel='noopener noreferrer' target='_blank'>
                          <Typography variant='body2' gutterBottom>
                            {t('login.forgotPassword')}
                          </Typography>
                        </RouterLink>)}
                      <StepFailMessage />
                      <Grid container className={classes.buttonContainer} style={{ marginTop: '15px' }}>
                        <Grid item xs={4}>
                          <BackButton currentStep={currentStep} doStepBack={doStepBack}/>
                        </Grid>
                        <Grid item xs={8}>
                          {/* STEP 10 SUBMIT IS HAPPENING HERE */}
                          <SubmitButton t={t} submit={!isDisabled} setIsEmpty={setIsEmpty} toCheck={{
                ...(beforeLogin ? {
                    name: isInvalidCharacters(name),
                    phoneNumber: noSpacesPhoneNum(phoneNumber) ||
                        validatePhoneNumber(phoneNumber),
                    email: noSpaceValue(email),
                    password: validatePassword(password) ||
                        noSpaceValue(password),
                } : {}),
                confirm: !confirm,
                serviceFeeCommitment: !serviceFeeCommitment
            }} externalIsLoading={submitting} customLabel={<> {t('apartment.actions.confirm')}</>}/>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <div className={classes.infoBoxWrapper}>
                    {/* Tunnusten luonnissa palvelusopimusvinkki (FV:n mallin mukaan); kirjautuneelle vahvistusstepin oma vinkki — EI taloyhtiöstepin step10Hint */}
                    <Suggest desktopMaxWidth="450px" content={t(`apartment.hints.${beforeLogin ? 'confirmBeforeLoginHint' : 'step12Hint'}`)} containerMaxWidth='550px' contentMaxWidth='450px'/>
                  </div>
                </Grid>
              </Grid>
            </>)}
        </Grid>
      </Grid>{' '}
    </form>);
};
const selector = formValueSelector('ApartmentConfirmationForm');
const mapStateToProps = (state: StateInterface) => {
    const isSVAMemberValue = selector(state, 'isSVAMember');
    return {
        confirm: selector(state, 'confirm'),
        serviceFeeCommitment: selector(state, 'serviceFeeCommitment'),
        isSVAMember: isSVAMemberValue === true || isSVAMemberValue === 'true',
        isMobile: selectIsMobile(state),
        name: selector(state, 'name'),
        phoneNumber: selector(state, 'phoneNumber'),
        email: selector(state, 'email'),
        password: selector(state, 'password')
    };
};
export default connect(mapStateToProps)(reduxForm({
    form: 'ApartmentConfirmationForm'
})(withTranslation()(ApartmentConfirmationForm as any) as any) as any) as any;
